import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { loadEmployerFilingsOverview } from './thunks/loadEmployerFilingsOverview.thunk';
import { loadEmployerFilingsAccess } from './thunks/loadEmployerFilingsAccess.thunk';

// One entity per project, each carrying its own filings.
const projectsAdapter = createEntityAdapter();

const employerFilingsSlice = createSlice({
  name: 'employerFilings',
  initialState: {
    projects: projectsAdapter.getInitialState(),
    employerProjectId: null,
    loading: false,
    error: null,
    latestRequestId: null,
    hasAccessByEmployerProjectId: {},
  },
  reducers: {},
  extraReducers(builder) {
    builder
      // LOAD overview:
      .addCase(loadEmployerFilingsOverview.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.latestRequestId = action.meta.requestId;

        // Opening another employer must not show the previous one's projects.
        if (state.employerProjectId !== action.meta.arg) {
          projectsAdapter.removeAll(state.projects);
          state.employerProjectId = action.meta.arg;
        }
      })
      .addCase(loadEmployerFilingsOverview.fulfilled, (state, action) => {
        // A slower answer for an employer the user already left is dropped.
        if (action.meta.requestId !== state.latestRequestId) {
          return;
        }
        state.loading = false;
        projectsAdapter.setAll(state.projects, action.payload.projects);
      })
      .addCase(loadEmployerFilingsOverview.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) {
          return;
        }
        state.loading = false;
        state.error = action.error;
      })
      // LOAD access:
      .addCase(loadEmployerFilingsAccess.fulfilled, (state, action) => {
        state.hasAccessByEmployerProjectId[action.payload.employerProjectId] =
          action.payload.hasAccess;
      })
      .addCase(loadEmployerFilingsAccess.rejected, (state, action) => {
        // Failing closed: no button when access could not be checked.
        state.hasAccessByEmployerProjectId[action.meta.arg] = false;
      });
  },
});

export const { selectAll: selectAllEmployerFilingsProjects } =
  projectsAdapter.getSelectors((state) => state.employerFilings.projects);

export default employerFilingsSlice.reducer;
